import { GetServerSideProps } from 'next';
import APIServices from '@/apiUtils/APIServices';
import { disableRightClick } from '@/helpers/windowHelper';

import dynamic from 'next/dynamic';
const NavbarNew = dynamic(() => import('@/components/layout/landing/NavbarNew'), { ssr: false });
const SEO = dynamic(() => import('@/components/landing/seo'), { ssr: false });
const Footer = dynamic(() => import('@/components/layout/landing/Footer'), { ssr: false });
const CourseDetailsPage = dynamic(() => import('@/components/landing/course/coursedetails/index'));
interface ISingleCourseData {
  meta_title: string;
  meta_description: string;
  image: string;
  meta_keywords: string;
  slug: string;
}

interface ISingleCourse {
  data: ISingleCourseData;
}

const SingleCourse = (props: ISingleCourse) => {
  disableRightClick();
  return (
    <>
      <SEO
        meta_title={props.data?.meta_title}
        meta_description={props.data?.meta_description}
        meta_keywords={props.data?.meta_keywords}
        photo={props.data?.image}
        canonical={`course/${props?.data?.slug}`}
      />
      <NavbarNew />
      {/* {props?.data && <TestCourseDetails course={props?.data} />} */}
      {props?.data && <CourseDetailsPage course={props?.data} />}
      <Footer />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async ({
  params: { slug },
}) => {
  const { data, success } = await new APIServices(`/course-list/${slug}`).get();
  return {
    props: {
      data: success ? data : null,
    },
  };
};

export default SingleCourse;
